import { createContext, useContext, useCallback } from "react";
import { t as translate } from "@/i18n/translations";
import { useAuth } from "@/contexts/AuthContext";

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const { user } = useAuth();
  const lang = user?.language || localStorage.getItem("sop_raft_lang") || "pt-BR";

  const t = useCallback((key) => translate(key, lang), [lang]);

  return (
    <LanguageContext.Provider value={{ lang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used within LanguageProvider");
  return ctx;
}
